type QUERIES_KEYS = Record<
  `${keyof typeof BREAKPOINTS}Down` | `${keyof typeof BREAKPOINTS}Up`,
  string
>;
export const BREAKPOINTS = {
  smallMobile: 360,
  mobile: 480,
  smallTablet: 640,
  tablet: 768,
  largeTablet: 1080,
  smallDesktop: 1200,
  largeDesktop: 1440,
  veryLargeDesktop: 1920,
  extraLargeDesktop: 2160,
} as const;

export const QUERIES = {
  smallMobileDown: `(max-width: ${BREAKPOINTS.smallMobile - 1}px)`,
  smallMobileUp: `(min-width: ${BREAKPOINTS.smallMobile}px)`,
  mobileDown: `(max-width: ${BREAKPOINTS.mobile - 1}px)`,
  mobileUp: `(min-width: ${BREAKPOINTS.mobile}px)`,
  smallTabletDown: `(max-width: ${BREAKPOINTS.smallTablet - 1}px)`,
  smallTabletUp: `(min-width: ${BREAKPOINTS.smallTablet}px)`,
  tabletDown: `(max-width: ${BREAKPOINTS.tablet - 1}px)`,
  tabletUp: `(min-width: ${BREAKPOINTS.tablet}px)`,
  largeTabletDown: `(max-width: ${BREAKPOINTS.largeTablet - 1}px)`,
  largeTabletUp: `(min-width: ${BREAKPOINTS.largeTablet}px)`,
  smallDesktopDown: `(max-width: ${BREAKPOINTS.smallDesktop - 1}px)`,
  smallDesktopUp: `(min-width: ${BREAKPOINTS.smallDesktop}px)`,
  largeDesktopDown: `(max-width: ${BREAKPOINTS.largeDesktop - 1}px)`,
  largeDesktopUp: `(min-width: ${BREAKPOINTS.largeDesktop}px)`,
  veryLargeDesktopDown: `(max-width: ${BREAKPOINTS.veryLargeDesktop - 1}px)`,
  veryLargeDesktopUp: `(min-width: ${BREAKPOINTS.veryLargeDesktop}px)`,
  extraLargeDesktopDown: `(max-width: ${BREAKPOINTS.extraLargeDesktop - 1}px)`,
  extraLargeDesktopUp: `(min-width: ${BREAKPOINTS.extraLargeDesktop}px)`,
} as const satisfies QUERIES_KEYS;

/**
 * Responsive type representing different screen sizes
 */
export type UseResponsive = {
  /** Small mobile devices (portrait phones, less than 360px) */
  isSmallMobileDown: boolean;
  /** Small mobile devices (portrait phones, more than 360px) */
  isSmallMobileUp: boolean;
  /** Mobile devices (portrait phones, less than 480px) */
  isMobileDown: boolean;
  /** Mobile devices (portrait phones, more than 480px) */
  isMobileUp: boolean;
  /** Small tablets (portrait tablets and large phones, less than 640px) */
  isSmallTabletDown: boolean;
  /** Small tablets (portrait tablets and large phones, more than 640px) */
  isSmallTabletUp: boolean;
  /** Tablets (portrait tablets and small laptops, less than 768px) */
  isTabletDown: boolean;
  /** Tablets (portrait tablets and small laptops, more than 768px) */
  isTabletUp: boolean;
  /** Large tablets (landscape tablets and laptops, less than 1080px) */
  isLargeTabletDown: boolean;
  /** Large tablets (landscape tablets and laptops, more than 1080px) */
  isLargeTabletUp: boolean;
  /** Small desktops (laptops and desktops, less than 1200px) */
  isSmallDesktopDown: boolean;
  /** Small desktops (large laptops and desktops, more than 1200px) */
  isSmallDesktopUp: boolean;
  /** Large desktops (large desktops, less than 1440px) */
  isLargeDesktopDown: boolean;
  /** Large desktops (large desktops, more than 1440px) */
  isLargeDesktopUp: boolean;
  /** Very large desktops (high-resolution desktops, less than 1920px) */
  isVeryLargeDesktopDown: boolean;
  /** Very large desktops (high-resolution desktops, more than 1920px) */
  isVeryLargeDesktopUp: boolean;
  /** Extra large desktops (ultra-high-resolution desktops, less than 2160px) */
  isExtraLargeDesktopDown: boolean;
  /** Extra large desktops (ultra-high-resolution desktops, more than 2160px) */
  isExtraLargeDesktopUp: boolean;
};
